var map = {
	"./archive.png": "./src/assets/file-icons/archive.png",
	"./audio.png": "./src/assets/file-icons/audio.png",
	"./excel.png": "./src/assets/file-icons/excel.png",
	"./file.png": "./src/assets/file-icons/file.png",
	"./folder.png": "./src/assets/file-icons/folder.png",
	"./image.png": "./src/assets/file-icons/image.png",
	"./pdf.png": "./src/assets/file-icons/pdf.png",
	"./powerpoint.png": "./src/assets/file-icons/powerpoint.png",
	"./text.png": "./src/assets/file-icons/text.png",
	"./video.png": "./src/assets/file-icons/video.png",
	"./word.png": "./src/assets/file-icons/word.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/file-icons sync recursive ^\\.\\/.*\\.png$";